import Api from 'utils/api'

export const fetchTemplate = ({ project, uuid }) =>
  Api.get(['templates', uuid], { project })
